export const WEB3FORMS_CONFIG = {
  accessKey: "1fd53f89-6516-4c06-8c6a-041feaecd6d7",
  endpoint: "https://api.web3forms.com/submit",
  toEmail: "lokesh1911e@gmail.com",
};
